module.exports = __webpack_public_path__ + "static/woman-on-the-beach-mobile.8a2d0ffd.webp";